import styled from 'styled-components';

import { Translate } from '@dreryk/react-common';
import { UserBarGroup, UserBarGroupLinkWrap } from '@dreryk/react-components';

import { protectFeature } from '~libs.shared.system';

import { appTranslationKeys } from '../translations';

const StyledUserBarGroupLinkWrap = styled(UserBarGroupLinkWrap)`
   color: ${(props) => props.theme.secondaryDark};
`;
StyledUserBarGroupLinkWrap.displayName = 'StyledUserBarGroupLinkWrap';

export const PayInvoicesUserBarGroup = (): JSX.Element | null => {
   return protectFeature(
      'creatingAppointments',
      null,
      <UserBarGroup testId={'payInvoices'}>
         <StyledUserBarGroupLinkWrap testId={'payInvoices'}>
            <Translate>{appTranslationKeys.payInvoices}</Translate>
         </StyledUserBarGroupLinkWrap>
      </UserBarGroup>
   );
};
